import { render, staticRenderFns } from "./pay-channel-group-management.vue?vue&type=template&id=6712c744&scoped=true&"
import script from "./pay-channel-group-management.vue?vue&type=script&lang=js&"
export * from "./pay-channel-group-management.vue?vue&type=script&lang=js&"
import style0 from "./pay-channel-group-management.vue?vue&type=style&index=0&id=6712c744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6712c744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6712c744')) {
      api.createRecord('6712c744', component.options)
    } else {
      api.reload('6712c744', component.options)
    }
    module.hot.accept("./pay-channel-group-management.vue?vue&type=template&id=6712c744&scoped=true&", function () {
      api.rerender('6712c744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-channel-management/pay-channel-group-management.vue"
export default component.exports